module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-1-95967469cc043de193c28591fab95f9c.jpg";